import { Grid, Typography } from '@mui/material'
import { FormType } from '../utils/sharedTypes'
import { resolveCommercialPricing, sumProductListingPrices } from '../utils/pricing'

type Props = {
  form: FormType
}

export default function FundingSummaryBankTransfer({ form }: Props) {
  const hasProducts = form.data.products.length > 0 && form.data.product === null
  const listing_price = hasProducts
    ? sumProductListingPrices(form.data.products)
    : form.data.product
    ? form.data.product.listing_price
    : 0

  const { amountToPay, commercialDiscount, hasCommercialDiscount, displayedFormationPrice } =
    resolveCommercialPricing({
      personalFunding: form.data.personal_funding,
      defaultPersonalFunding: form.data.default_personal_funding,
      listingPrice: listing_price,
    })

  return form.data.registration_type == 'PreConfiguredRegistration' ? (
    <>
      <Grid item container direction="row" justifyContent="space-between" wrap="nowrap">
        <Grid item sx={{ maxWidth: '50%' }}>
          <Typography variant="body2">Prix {hasProducts ? 'total de mon parcours de' : 'de ma'} formation</Typography>
        </Grid>
        <Typography variant="body1" sx={{ textAlign: 'right', fontWeight: 400 }}>
          {Intl.NumberFormat('fr-FR', {
            style: 'currency',
            currency: 'EUR',
            maximumFractionDigits: 2,
          }).format(displayedFormationPrice) || '-'}
        </Typography>
      </Grid>

      {hasCommercialDiscount && (
        <Grid item container direction="row" justifyContent="space-between" wrap="nowrap">
          <Grid item sx={{ maxWidth: '50%' }}>
            <Typography variant="body2">Remise commerciale</Typography>
          </Grid>
          <Typography variant="body1" sx={{ textAlign: 'right', fontWeight: 400 }}>
            {Intl.NumberFormat('fr-FR', {
              style: 'currency',
              currency: 'EUR',
              maximumFractionDigits: 2,
            }).format(commercialDiscount) || '-'}
          </Typography>
        </Grid>
      )}

      <Grid item container direction="row" justifyContent="space-between" wrap="nowrap">
        <Grid item>
          <Typography variant="body2">À payer aujourd'hui</Typography>
        </Grid>
        <Typography variant="body1" sx={{ textAlign: 'right', fontWeight: 500 }}>
          {Intl.NumberFormat('fr-FR', {
            style: 'currency',
            currency: 'EUR',
            maximumFractionDigits: 2,
          }).format(amountToPay) || '-'}
        </Typography>
      </Grid>
    </>
  ) : (
    <Grid item container direction="row" justifyContent="space-between" wrap="nowrap">
      <Grid item>
        <Typography variant="body2">Prix de la formation</Typography>
      </Grid>
      <Typography variant="body1" sx={{ textAlign: 'right', fontWeight: 500 }}>
        {Intl.NumberFormat('fr-FR', {
          style: 'currency',
          currency: 'EUR',
          maximumFractionDigits: 2,
        }).format(amountToPay) || '-'}
        {" à régler dès aujourd'hui"}
      </Typography>
    </Grid>
  )
}
